define('models/historicalTransfer',[
    'models/base/baseModel'
],
function (BaseModel) {
    'use strict';
    return BaseModel.extend({});
});
